import React, { useEffect, useState } from 'react'
import { ArrowBack } from '@mui/icons-material'
import Table from '../../../shared/ui/Table'
import { useGetRequest } from '../../../shared/hooks/requests'
import { TENANT_ANALYTICS_CATEGORY } from '../../../shared/utils/urls'
import { AttendanceModalTableItems } from './AttendanceModalTableItems'

const cols = [
    {
        id: 1,
        title: 'Main Photo',
    },
    {
        id: 2,
        title: 'Snapshot Url',
    },
    {
        id: 3,
        title: 'Attendance Datetime',
    },
    {
        id: 4,
        title: 'CreatedAt',
    },
    {
        id: 5,
        title: 'Trusted Datetime',
    },
    {
        id: 6,
        title: 'Firstname',
    },
    {
        id: 7,
        title: 'Lastname',
    },
    {
        id: 8,
        title: 'Identity Group',
    },
    {
        id: 9,
        title: 'External ID',
    },
    {
        id: 10,
        title: 'App VersionCode',
    },
    {
        id: 11,
        title: 'Device ID',
    },
    {
        id: 12,
        title: 'Device Name',
    },
    {
        id: 13,
        title: 'Distance Location',
    },
    {
        id: 14,
        title: 'Img SizeType',
    },
]

export function AttendanceBlank({ category, startDate, endDate, id, label, onBack, region, district, model }) {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const getByCategory = useGetRequest()
    const data = getByCategory.response ? getByCategory.response : null
    const total = getByCategory.response ? getByCategory.response.total : null

    useEffect(() => {
        getByCategory.request({
            url: TENANT_ANALYTICS_CATEGORY,
            params: {
                category,
                start_date: startDate,
                end_date: endDate,
                tenant_entity_id: id,
                page,
                ...(model ? { device_id: model } : {}),
                page_size: pageSize,
                ...(region ? { region_id: region } : {}),
                ...(district ? { district_id: district } : {}),
            },
        })
    }, [page, pageSize])

    return (
        <div className="bg-white flex flex-col items-start gap-[10px]">
            <div className="w-full p-[10px] flex items-center gap-[20px]">
                <div className="py-[7px] px-[5px] flex items-center justify-center rounded-[20px] bg-gray-200/50">
                    <ArrowBack
                        onClick={onBack}
                        className="cursor-pointer hover:text-main-100 transition"
                    />
                </div>
                <span className="text-[16px] font-[500] text-black">{label}</span>
            </div>
            <Table
                page={page - 1}
                loading={getByCategory.loading}
                rowsPerPage={pageSize}
                onPageChange={(e, newPage) => setPage(newPage + 1)}
                onRowsPerPageChange={(e) => {
                    setPageSize(parseInt(e.target.value, 10))
                    setPage(1)
                }}
                cols={cols}
                totalCount={total}
                rows={data?.data}
                renderItem={(item) => (
                    <AttendanceModalTableItems
                        key={item.id}
                        item={item}
                    />
                )}
            />
        </div>
    )
}
